import { render, staticRenderFns } from "./ShareVideosDialog.vue?vue&type=template&id=6363f3e4&scoped=true&"
import script from "./ShareVideosDialog.vue?vue&type=script&lang=js&"
export * from "./ShareVideosDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6363f3e4",
  null
  
)

export default component.exports